<template>
  <div class="finance-page">
    <BackButton :inert="anyMenusOpen" />
    <div class="page-title">Onboarding Dashboard</div>
    <div>
      <OnboardingTable
        :key="`onboarding-section-${reloadKey}`"
        :items="list"
        @refresh="reloadKey++"
        :class="{ 'table-loading': loadingList }"
        :listOptions="listOptions"
        @orderUpdate="orderUpdate($event)"
        @filterUpdate="filterUpdate($event)"
        :inertProp="anyMenusOpen"
        @menuEvent="menus.table = $event"
      >
        <template #actions>
          <TableOptionsResetBtn
            :enabled="anyActiveListOptions"
            @input="resetListOptions"
            :inert="anyMenusOpen"
          />
          <div class="payments-table__action">
            <div class="payments-table__action__label">Filter by:</div>
            <v-overlay
              :value="menus.filters"
              @click.native.stop="closeFilters()"
            />
            <v-menu
              bottom
              offset-y
              :close-on-click="false"
              :close-on-content-click="false"
              v-model="menus.filters"
              light
              class="filters-menu"
              content-class="filters-menu__content"
            >
              <template v-slot:activator="{ on }">
                <TableActiveFilters
                  v-on="on"
                  @openMenu="menus.filters = !menus.filters"
                  :listOptions="listOptions"
                  :fields="filterFields"
                  @resetFilter="resetFilter($event)"
                  :activeListOption="activeListOption"
                  ref="tableActiveFilters"
                  :filtersMenu="menus.filters"
                  :inert="anyMenusOpen && !menus.filters"
                />
              </template>
              <v-card
                class="filters-menu__content__card"
                :aria-modal="menus.filters"
                :aria-live="menus.filters ? 'polite' : false"
              >
                <div class="filters-menu__body">
                  <v-expansion-panels
                    v-model="filterPanels"
                    multiple
                    flat
                  >
                    <TableRadioFilterPanel
                      :listOptions="listOptions"
                      fieldName="hr"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="Hire Request(s)"
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                      :items="yesNoAllItems"
                    />
                    <TableOptionsFilterPanel
                      :listOptions="listOptions"
                      fieldName="w9"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="W-9 Status"
                      selectAll
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                    />
                    <TableOptionsFilterPanel
                      :listOptions="listOptions"
                      fieldName="ach"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="ACH Status"
                      selectAll
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                    />
                    <TableOptionsFilterPanel
                      :listOptions="listOptions"
                      fieldName="msa"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="MSA Status"
                      selectAll
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                    />
                    <TableOptionsFilterPanel
                      :listOptions="listOptions"
                      fieldName="ga_withholding"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="GA Film Tax Credit Status"
                      selectAll
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                    />
                    <TableRadioFilterPanel
                      :listOptions="listOptions"
                      fieldName="confirmed"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="Account Claimed"
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                      :items="yesNoAllItems"
                    />
                    <TableRadioFilterPanel
                      :listOptions="listOptions"
                      fieldName="qb_is_linked"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="Quickbooks Vendor"
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                      :items="yesNoAllItems"
                    />
                    <TableDateFilterPanel
                      :listOptions="listOptions"
                      fieldName="created_at"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="Date Created"
                    />
                    <TableOptionsFilterPanel
                      :listOptions="listOptions"
                      fieldName="account_type"
                      @filterUpdate="filterMenuUpdate($event)"
                      fieldLabel="Account Type"
                      selectAll
                      reset
                      :defaultListOptions="getDefaultListOptions()"
                    />
                  </v-expansion-panels>
                </div>
              </v-card>
            </v-menu>
          </div>
          <div
            class="payments-table__action"
            :inert="anyMenusOpen"
          >
            <div class="payments-table__action__label"></div>
            <TextField
              v-model="searchInputBuffer"
              placeholder="Search"
              inputOnEnter
              @enter="searchInputEvent"
              ref="searchField"
            />
          </div>
          <div
            class="payments-table__secondary-actions"
            :inert="anyMenusOpen"
          >
            <div class="
                payments-table__action
                payments-table__action--compact
                payments-table__action--download
              ">
              <ActionsMenu
                @close="menus.download = false"
                @toggle="menus.download = !menus.download"
                :menu="menus.download"
                themeDisabledPage
                icon="$download"
                :iconSize="24"
                :inertProp="anyMenusOpen || inertProp"
              >
                <form
                  method="post"
                  :action="`${apiDomain}/api/v1/profile_side/creators/onboarding_csv`"
                  target="_blank"
                  style="margin-bottom: 21px"
                >
                  <input
                    type="hidden"
                    name="token"
                    :value="$store.getters['auth/token']"
                  />
                  <input
                    type="hidden"
                    name="all"
                    value="true"
                  />
                  <input
                    type="hidden"
                    v-for="item in Object.entries(listParams)"
                    :key="`listParams-${item[0]}`"
                    :name="item[0]"
                    :value="item[1]"
                  />
                  <v-btn
                    type="submit"
                    color="#56565A"
                    elevation="0"
                    style="color: white !important"
                  >Export CSV</v-btn>
                </form>
              </ActionsMenu>
            </div>
            <TableOptionsResetBtn
              :enabled="anyActiveListOptions"
              @input="resetListOptions"
              mobile
            />
          </div>
        </template>
        <template #pagination>
          <TablePagination
            :page="page"
            :totalPages="totalPages"
            @input="page = $event"
            :key="`pagination-${reloadKey}`"
            :inert="anyMenusOpen"
          />
        </template>
      </OnboardingTable>
    </div>
  </div>
</template>

<script>
import OnboardingTable from "./onboarding-dashboard/table.onboarding-dashboard";
import onboardingTableActions from "@/mixins/onboarding-table-actions.mixin";
import TableOptionsFilterPanel from "@/components/tables/TableOptionsFilterPanel";
import TableRadioFilterPanel from "@/components/tables/TableRadioFilterPanel";
import TableDateFilterPanel from "@/components/tables/TableDateFilterPanel";
import TableActiveFilters from "@/components/tables/TableActiveFilters";
import paginatedTable from "@/mixins/paginated-table.mixin";
import TablePagination from "@/components/tables/TablePagination";
import { profileToApi } from "@/lib/domains";
import TableOptionsResetBtn from "@/components/tables/TableOptionsResetBtn";
import pageMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-page.mixin.js";

export default {
  head() {
    return {
      title: "Onboarding Dashboard",
      titleTemplate: "%s | iU Community",
    };
  },
  mixins: [onboardingTableActions, paginatedTable, pageMenuEventBubbler],
  components: {
    OnboardingTable,
    TableOptionsFilterPanel,
    TableRadioFilterPanel,
    TableDateFilterPanel,
    TableActiveFilters,
    TablePagination,
    TableOptionsResetBtn,
  },
  data() {
    return {
      list: [],
      loadingList: false,
      listOptions: this.getDefaultListOptions(false),
      filterFields: [
        { name: "hr", label: "Hire Request(s)" },
        { name: "w9", label: "W-9 Status" },
        { name: "ach", label: "ACH Status" },
        { name: "msa", label: "MSA Status" },
        { name: "ga_withholding", label: "GA Film Tax Credit Status" },
        { name: "confirmed", label: "Account Claimed" },
        { name: "created_at", label: "Date Created" },
        { name: "qb_is_linked", label: "QB Vendor" },
        { name: "account_type", label: "Account Type" },
      ],
      reloadKey: 1,
      yesNoAllItems: [
        {
          title: "Yes",
          value: "yes",
        },
        {
          title: "No",
          value: "no",
        },
        {
          title: "All",
          value: "all",
        },
      ],
      apiDomain: profileToApi()[window.location.origin],
      menus: {
        filters: false,
        download: false,
        table: false,
      },
      searchInputBuffer: "",
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    getParams() {
      const params = { ...this.listParams };
      params.page = this.page;
      params.per = 10;
      return params;
    },
    async fetchList() {
      this.loadingList = true;
      const params = this.getParams();
      const { data } = await this.$api.Creator.onboardingList(params);
      this.list = data.creators;
      this.totalPages = data.total_pages;
      this.loadingList = false;
      if (this.focusOnSearch) {
        this.focusOnSearch = false;
        this.$nextTick(() => this.$refs.searchField.$refs.input.focus());
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/payments/payments-section.scss";
@import "@/styles/table-filters-menu.scss";
</style>
